/**
 * URL configuration
 *
 * LOCAL (npm start on localhost:3000):
 *   API_URL  → http://127.0.0.1:8000/api   (Laravel API)
 *   WEB_URL  → http://127.0.0.1:8000       (Laravel backend — legacy Blade routes for verification)
 *   APP_URL  → http://localhost:3000       (React SPA — use reportRoutes.js paths under this host)
 *
 * PRODUCTION:
 *   REACT_APP_API_URL / REACT_APP_WEB_URL in frontend/.env.production
 *   FRONTEND_URL in backend/.env (React SPA origin; other-report redirects here)
 *
 * Reports: navigate with React routes from constant/reportRoutes.js (not WEB_URL/other-report).
 * Legacy Blade routes remain on WEB_URL for parity testing only.
 *
 * See env.urls.example and frontend/docs/PRODUCTION-REPORTS.md
 */
function trimTrailingSlash(url) {
  if (!url || typeof url !== "string") {
    return "";
  }
  return url.replace(/\/+$/, "");
}

function isLocalDevHost() {
  if (process.env.NODE_ENV === "development") {
    return true;
  }
  if (typeof window === "undefined") {
    return false;
  }
  const host = window.location.hostname;
  return host === "localhost" || host === "127.0.0.1" || host === "[::1]";
}

function readRuntimeConfig() {
  if (isLocalDevHost()) {
    return {};
  }
  if (typeof window !== "undefined" && window.__PETROSMART_CONFIG__) {
    return window.__PETROSMART_CONFIG__;
  }
  return {};
}

const runtime = readRuntimeConfig();

const LOCAL_API = "http://127.0.0.1:8000/api";
const LOCAL_WEB = "http://127.0.0.1:8000";
const LOCAL_APP = "http://localhost:3000";

// On localhost always use LOCAL_* — production build inlines REACT_APP_* from .env.production.
const resolvedApiUrl = isLocalDevHost()
  ? LOCAL_API
  : runtime.REACT_APP_API_URL || process.env.REACT_APP_API_URL || "";

const resolvedWebUrl = isLocalDevHost()
  ? LOCAL_WEB
  : runtime.REACT_APP_WEB_URL || process.env.REACT_APP_WEB_URL || "";

export const API_URL = trimTrailingSlash(resolvedApiUrl);
export const WEB_URL = trimTrailingSlash(resolvedWebUrl);

/** React SPA origin — report pages live here (see constant/reportRoutes.js). */
export const APP_URL = trimTrailingSlash(
  typeof window !== "undefined" && window.location?.origin
    ? window.location.origin
    : isLocalDevHost()
      ? LOCAL_APP
      : runtime.REACT_APP_FRONTEND_URL ||
        process.env.REACT_APP_FRONTEND_URL ||
        ""
);

if (typeof window !== "undefined" && !isLocalDevHost()) {
  if (!API_URL || !WEB_URL) {
    console.error(
      "[Petrosmart] Missing production URL config. Set frontend/.env.production or run scripts/generate-runtime-config.sh before deploy. See env.urls.example."
    );
  } else {
    const reactOrigin = window.location.origin;
    if (WEB_URL === reactOrigin) {
      console.warn(
        "[Petrosmart] WEB_URL must be the Laravel backend host, not the React SPA origin."
      );
    }
  }
}
